import {
    PERSONNEL_LEVELS_FETCHING,
PERSONNEL_LEVELS_FAILED,
PERSONNEL_LEVELS_SUCCESS
} from "../actions/types";

const initialState = {
    result: null,
    isFetching:false,
    isError: false
};

export default function (state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
        case PERSONNEL_LEVELS_FETCHING:
            return { ...state, result: null, isFetching: true, isError: false };
        case PERSONNEL_LEVELS_FAILED:
            return { ...state, result: null, isFetching: false, isError: true };
        case PERSONNEL_LEVELS_SUCCESS:
            return { ...state, result: payload, isFetching: false, isError: false };
        default:
            return state;
    }
};
